// Не меняет поля формы профиля. Поддерживает старые ответы с ФИО в name.
export function personName(person, fallback = 'Сотрудник') {
  if (!person) return fallback;
  if (person.full_name) return String(person.full_name).trim() || fallback;
  const name = String(person.name || person.first_name || '').trim();
  const last = String(person.last_name || '').trim();
  if (!last || name.split(/\s+/).includes(last)) return name || last || fallback;
  return [name, last].filter(Boolean).join(' ') || fallback;
}